import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewActionItemsActions from '../review-action-items/review-action-items.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewActionItemsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewActionItemsActions.ReviewActionItemsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_ACTION_ITEMS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewActionItemsActions.ReviewActionItemsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewActionItemsActions.ReviewActionItemsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewActionItemsActions.ReviewActionItemsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewActionItemsActions.ReviewActionItemsRefresh());
          break;
      }
    });
  }
}
